/**
 * Утилиты для повторных попыток HTTP запросов
 */

import type { RetryStrategy } from './types'

/**
 * Вычислить задержку перед повторной попыткой на основе стратегии
 * 
 * @param attempt - Номер попытки (0-based)
 * @param strategy - Стратегия увеличения задержки
 * @param baseDelay - Базовая задержка в миллисекундах
 * @param maxDelay - Максимальная задержка в миллисекундах
 * @returns Задержка в миллисекундах
 */
export const calculateRetryDelay = (
    attempt: number,
    strategy: RetryStrategy = 'immediate',
    baseDelay: number = 1000,
    maxDelay: number = 10000
): number => {
    let delay: number

    switch (strategy) {
        case 'immediate':
            delay = 0
            break
        case 'exponential':
            delay = baseDelay * Math.pow(2, attempt)
            break
        case 'linear':
            delay = baseDelay * (attempt + 1)
            break
        case 'fixed':
            delay = baseDelay
            break
        case 'fibonacci':
            if (attempt === 0) {
                delay = baseDelay
            } else if (attempt === 1) {
                delay = baseDelay
            } else {
                let fib1 = 1, fib2 = 1
                for (let i = 2; i <= attempt; i++) {
                    const temp = fib1 + fib2
                    fib1 = fib2
                    fib2 = temp
                }
                delay = baseDelay * fib2
            }
            break
        default:
            delay = 0
    }

    return Math.min(delay, maxDelay)
}

/**
 * Задержка выполнения
 * 
 * @param ms - Миллисекунды
 */
export const sleep = (ms: number): Promise<void> => {
    return new Promise(resolve => setTimeout(resolve, ms))
}
